import script from "./stepCard.vue?vue&type=script&setup=true&lang=js"
export * from "./stepCard.vue?vue&type=script&setup=true&lang=js"

import "./stepCard.vue?vue&type=style&index=0&id=199ca084&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199ca084"]])

export default __exports__